"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var dom_ready_1 = require("../util/dom-ready");
var css = require("./index.scss");
require("../theme.ts");
var Player = /** @class */ (function (_super) {
    __extends(Player, _super);
    function Player() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.totalTime = '00:00';
        _this.muted = false;
        return _this;
    }
    Player.prototype.$ = function (node) {
        var dom = this.shadowRoot.querySelectorAll(node);
        return dom.length > 1 ? dom : dom[0];
    };
    Player.prototype.dom = function () {
        var _this = this;
        this.video = this.$('video');
        this.video.volume = 0.5;
        setVolume(this.video.volume * 10, this.$('.line'));
        this.$('.is-volume').onclick = function () { return _this.volume(); };
        this.$('.line').forEach(function (item, index) {
            item.onclick = function () {
                _this.video.volume = (index + 1) / 10;
                setVolume(index + 1, _this.$('.line'));
            };
        });
        this.$('.progress').onmousedown = function (e) { return _this.progress(e); };
        this.video.onwaiting = function () { return _this.waiting(); };
        this.video.oncanplay = function () { return _this.canplay(); };
        this.video.ontimeupdate = function () { return _this.updating(); };
        this.$('.cycle').onmousedown = function (e) { return _this.down(e); };
        this.$('.eplayer').onmousemove = function () { return _this.alow(); };
        document.onkeydown = function (e) { return _this.keydown(e); };
        this.$('.ep-full').onclick = function () { return _this.full(); };
        this.$('.ep-video').onclick = this.$('.is-play').onclick = function () { return _this.play(); };
        this.video.onended = function () { return _this.ended(); };
        this.$('.mark').ondblclick = function () {
            clearTimeout(_this.timer);
            _this.full();
        };
    };
    Player.prototype.waiting = function () {
        this.$('.mark').classList.remove('playing');
        this.$('.mark').classList.add('loading');
    };
    Player.prototype.canplay = function () {
        var _this = this;
        this.$('.mark').classList.remove('loading');
        this.$('.mark').classList.add('playing');
        this.$('.playing').onclick = function () {
            clearTimeout(_this.timer);
            _this.timer = setTimeout(function () {
                _this.play();
            }, 200);
        };
        this.$('.total').innerHTML = getTimeStr(this.video.duration);
        this.totalTime = getTimeStr(this.video.duration);
        this.$('.total').innerHTML = this.totalTime;
    };
    Player.prototype.play = function () {
        if (this.video.paused) {
            this.video.play();
            this.isPlaying = true;
            this.$('.ep-video').style.display = 'none';
        }
        else {
            this.video.pause();
            this.isPlaying = false;
            this.$('.ep-video').style.display = 'block';
        }
        this.update();
    };
    Player.prototype.volume = function () {
        if (this.video.muted) {
            this.video.muted = false;
            this.muted = false;
            setVolume(this.video.volume * 10, this.$('.line'));
        }
        else {
            this.muted = true;
            this.video.muted = true;
            setVolume(0, this.$('.line'));
        }
        this.update();
    };
    Player.prototype.updating = function () {
        var cTime = getTimeStr(this.video.currentTime);
        if (this.video.buffered.length) {
            var bufferEnd = this.video.buffered.end(this.video.buffered.length - 1);
            this.$('.buffer').style.width =
                (bufferEnd / this.video.duration) * this.$('.progress').clientWidth +
                    'px';
        }
        var offset = (this.video.currentTime / this.video.duration) * this.$('.bg').clientWidth;
        this.$('.now').innerHTML = cTime;
        this.$('.current').style.width = offset + 'px';
    };
    Player.prototype.progress = function (e) {
        var offset = e.offsetX / this.$('.progress').offsetWidth;
        this.video.currentTime = this.video.duration * offset;
    };
    Player.prototype.down = function (e) {
        var _this = this;
        e.stopPropagation();
        this.disX = e.clientX - this.$('.cycle').offsetLeft;
        document.onmousemove = function (e) { return _this.move(e); };
        document.onmouseup = function () {
            e.stopPropagation();
            document.onmousemove = null;
            document.onmouseup = null;
        };
    };
    Player.prototype.move = function (e) {
        var _this = this;
        e.stopPropagation();
        var offset = e.clientX - this.disX + 7;
        if (offset < 0)
            offset = 0;
        if (offset > this.$('.progress').clientWidth) {
            offset = this.$('.progress').clientWidth;
        }
        this.$('.current').style.width = offset + 'px';
        this.video.currentTime =
            (offset / this.$('.progress').clientWidth) * this.video.duration;
        document.onmousemove = null;
        setTimeout((document.onmousemove = function (e) {
            if (e)
                _this.move(e);
        }), 30);
    };
    Player.prototype.alow = function () {
        var _this = this;
        clearTimeout(this.timer);
        this.$('.controls').style.bottom = 0;
        this.$('.ep-video').style.bottom = 70 + 'px';
        this.timer = setTimeout(function () {
            _this.$('.controls').style.bottom = -50 + 'px';
            _this.$('.ep-video').style.bottom = 25 + 'px';
        }, 5000);
    };
    Player.prototype.keydown = function (e) {
        switch (e.keyCode) {
            case 37:
                this.video.currentTime -= 10;
                break;
            case 39:
                this.video.currentTime += 10;
                break;
            case 38:
                setVolume(this.video.volume.toFixed(1) * 10, this.$('.line'));
                break;
            case 40:
                setVolume(this.video.volume.toFixed(1) * 10, this.$('.line'));
                break;
            case 32:
                this.play();
                break;
            default:
        }
    };
    Player.prototype.ended = function () {
        this.isPlaying = false;
        this.update();
    };
    Player.prototype.full = function () {
        if (isFullScreen()) {
            document.exitFullscreen();
        }
        else {
            var el = this.$('.eplayer');
            var rfs = el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullscreen;
            return rfs.call(el);
        }
    };
    Player.prototype.installed = function () {
        var _this = this;
        dom_ready_1.domReady(function () {
            _this.update();
            _this.dom();
        });
    };
    Player.prototype.render = function (props) {
        // this.stream(props.src, props.type)
        return (omi_1.h("div", { class: "eplayer" },
            omi_1.h("video", { id: "video", class: "video", src: props.src }),
            omi_1.h("div", { class: "mark loading" }),
            omi_1.h("div", { class: "controls", style: "bottom:-50px" },
                omi_1.h("div", { class: "progress" },
                    omi_1.h("b", { class: "bg" }),
                    omi_1.h("b", { class: "buffer" }),
                    omi_1.h("div", { class: "current", style: "width:0" },
                        omi_1.h("div", { class: "dot" }),
                        omi_1.h("div", { class: "cycle" }))),
                omi_1.h("div", { class: "options" },
                    omi_1.h("div", { class: "left" },
                        omi_1.h("svg", { xmlns: "http://www.w3.org/2000/svg", class: 'is-play icon', width: "24", height: "24", viewBox: "0 0 24 24" },
                            omi_1.h("path", { d: this.isPlaying ? "M6 19h4V5H6v14zm8-14v14h4V5h-4z" : "M8 5v14l11-7z", fill: "currentColor" }),
                            omi_1.h("path", { d: "M0 0h24v24H0z", fill: "none" })),
                        omi_1.h("span", { class: "time" },
                            omi_1.h("b", { class: "now" }, "00:00"),
                            " / ",
                            omi_1.h("b", { class: "total" }, this.totalTime))),
                    omi_1.h("div", { class: "right" },
                        omi_1.h("svg", { class: "is-volume icon", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
                            omi_1.h("path", { fill: "currentColor", d: !this.muted ? "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" : "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" }),
                            omi_1.h("path", { d: "M0 0h24v24H0z", fill: "none" })),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("span", { class: "line" },
                            omi_1.h("i", null)),
                        omi_1.h("svg", { class: "ep-full icon", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
                            omi_1.h("path", { d: "M0 0h24v24H0z", fill: "none" }),
                            omi_1.h("path", { fill: "currentColor", d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" }))))),
            omi_1.h("svg", { xmlns: "http://www.w3.org/2000/svg", class: "ep-video icon", width: "24", height: "24", viewBox: "0 0 24 24" },
                omi_1.h("path", { d: "M0 0h24v24H0z", fill: "none" }),
                omi_1.h("path", { fill: "currentColor", d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" }))));
    };
    Player.css = css;
    Player.propTypes = {
        src: String,
        type: String
    };
    Player = __decorate([
        omi_1.tag('m-player')
    ], Player);
    return Player;
}(omi_1.WeElement));
exports.default = Player;
function getTimeStr(time) {
    var h = Math.floor(time / 3600);
    var m = Math.floor((time % 3600) / 60);
    var s = Math.floor(time % 60);
    h = h >= 10 ? h : '0' + h;
    m = m >= 10 ? m : '0' + m;
    s = s >= 10 ? s : '0' + s;
    return h === '00' ? m + ':' + s : h + ':' + m + ':' + s;
}
function setVolume(index, node) {
    for (var j = index; j < node.length; j++) {
        node[j].classList.remove('active');
    }
    for (var i = 0; i < index; i++) {
        node[i].classList.add('active');
    }
}
function isFullScreen() {
    return document.fullscreen;
}
